module.exports = __webpack_public_path__ + "assets/80000bd3b8ad94af0bf92fecfd045f7a.png";